import { makeAutoObservable } from 'mobx';
import { SettingsStore } from '@monorepo/controlled/src/stores/settings.store';
import { FilterStore } from '@monorepo/controlled/src/stores/filter.store';
import { TableStore } from '@monorepo/controlled/src/stores/table.store';
import { filterPrototypesByProp } from '../../components/filters-menu/filters';
import { HttpStore } from '@monorepo/controlled/src/stores/http.store';
import { IPerformanceOptions, PerformancesColumnsSnakeCase } from '../../hooks/apis/use-reports-list';
import { ReportResponse } from '../../models/report.model';
import {
	IDomainCampaignsStatus,
	IDomainHistory,
	IDomainPertargetingStatus,
	IDomainScore,
	IDomainsPerformance,
} from '../../models/domain.models';
import { AdminxReporterApi } from '../../apis/adminx-reporter.api';

export enum DomainFiltersStoreKeys {
	Domains = 'domains',
}

export class DomainsStore {
	settingsStore: SettingsStore;
	list = new HttpStore<IPerformanceOptions, ReportResponse<IDomainsPerformance>>({
		httpFunc: AdminxReporterApi.report,
		model: ReportResponse<IDomainsPerformance>,
	});
	scores = new HttpStore<IPerformanceOptions, ReportResponse<IDomainScore>>({
		httpFunc: AdminxReporterApi.report,
		model: ReportResponse<IDomainScore>,
	});
	history = new HttpStore<IPerformanceOptions, ReportResponse<IDomainHistory>>({
		httpFunc: AdminxReporterApi.report,
		model: ReportResponse<IDomainHistory>,
	});
	campaignStatus = new HttpStore<IPerformanceOptions, ReportResponse<IDomainCampaignsStatus>>({
		httpFunc: AdminxReporterApi.report,
		model: ReportResponse<IDomainCampaignsStatus>,
	});
	pretargetingStatus = new HttpStore<IPerformanceOptions, ReportResponse<IDomainPertargetingStatus>>({
		httpFunc: AdminxReporterApi.report,
		model: ReportResponse<IDomainPertargetingStatus>,
	});

	constructor(settingsStore: SettingsStore) {
		makeAutoObservable(this);
		this.settingsStore = settingsStore;
		this.createDefaultFilters();
	}

	createDefaultFilters() {
		Object.values(DomainFiltersStoreKeys).map((key: DomainFiltersStoreKeys) => {
			if (!this.settingsStore.getPages().get(key)) {
				this.settingsStore.getPages().set(key, { tableStore: new TableStore() });
			}
			const domainsFilterByKey = new FilterStore({
				key,
				currentFilters: undefined,
				filterPrototypesByProp,
			});
			this.settingsStore.getPages().get(key)?.tableStore.setFiltersStore(key, domainsFilterByKey);
		});
	}

	scoresGroupBy = [
		'campaign_id',
		'campaign_name',
		'creative_group_id',
		'creative_group_name',
		'format',
		'scorer_class',
		'wins',
		'sales',
		'score',
		'created_by',
		'created_at',
		'updated_at',
	] as PerformancesColumnsSnakeCase[];

	pretargetingStatusGroupBy = ['id', 'name', 'billing_id', 'type', 'mode'] as PerformancesColumnsSnakeCase[];
	campaignStatusGroupBy = ['campaign_id', 'campaign_name', 'domain', 'campaign_status', 'list_type'] as PerformancesColumnsSnakeCase[];
	historyGroupBy = [
		'id',
		'domain_status',
		'description',
		'billing_id',
		'billing_name',
		'created_by',
		'created_at',
	] as PerformancesColumnsSnakeCase[];
}
